import CheatMenu from './CheatMenu';

export default CheatMenu;
